<template>
  <div class="subApp">
    <!-- 内容容器 -->
    <div class="app-container">
      <router-view/>
    </div>
    <!-- tabBar菜单 -->
    <tabbar v-if="$route.path=='/achievement'||$route.path=='/achievementDetail'||$route.path=='/member'||$route.path=='/ranking'||$route.path=='/me'"></tabbar>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'app',
  data () {
    return {}
  },
  components:{
    'tabbar':() => import('@/components/tabbar')
    
  },
  mounted() {
     window.onresize = ()=>{
       return(()=>{
         Toast('提示内容')
       })()
     }
  }
}
</script>

<style lang="scss">
  .app-container{

  }
</style>
